// Trilingual strings for the Hotel Guest Assistant (Phase B).
// Convention mirrors HotelGuestFlow.jsx inline text objects.

export const tl = (obj, base, lang) => {
    if (!obj) return '';
    return obj[`${base}_${lang}`] || obj[`${base}_en`] || obj[base] || '';
};

export const TEXT = {
    en: {
        title: 'Guest Assistance Platform',
        submit: 'Submit', requestSent: 'Request submitted',
        detailsPlaceholder: 'Add details (optional)',
        propertyPhotoHelper: 'Add a photo to help us understand the issue (optional).',
        room: 'Room',
        roomTitle: 'What room are you staying in?',
        roomHint: 'Your room number lets us send requests to the right team.',
        roomPlaceholder: 'Room number',
        continue: 'Continue',
        roomNotFound: "We couldn't find that room. Please check the number.",
        roomInvalid: 'Please enter a valid room number.',
        demoRoomFormat: 'In this demo, enter any 3-digit room or unit number (for example 214).',
        demoPinFormat: 'In this demo, enter any 4-digit code (for example 1234).',
        // DEMO ONLY (hotel demo card): one-tap check-in so a presenter does
        // not type a room, a name and a PIN in front of an audience.
        demoGuestCta: 'Continue as demo guest (Room {room})',
        demoTenantCta: 'Continue as demo tenant (Unit {unit})',
        demoTenantHint: 'Or register above, like a real resident.',
        demoGuestHint: 'Or register above, like a real guest.',
        sessionExpired: 'Your session expired. Please confirm your room again.',
        menuTitle: 'How can we help?',
        changeRoom: 'Change room',
        residentAssistTitle: 'Communication Portal',
        roomTitleUnit: 'What is your unit number?',
        roomHintUnit: 'Your unit number lets us route requests to the right team.',
        roomPlaceholderUnit: 'Unit number',
        changeUnit: 'Change unit',
        sessionLength: 'Keep me signed in for',
        back: 'Back',
        done: 'Done',
        send: 'Send request',
        sending: 'Sending\u2026',
        requestProgress: 'Request progress',
        shieldSent: 'Sent',
        shieldPending: 'Pending',
        shieldReceived: 'Received',
        shieldCompleted: 'Completed',
        shieldCancelled: 'Cancelled',
        shieldSentHint: 'Your request was sent',
        shieldPendingHint: 'Waiting for the team to see it',
        shieldReceivedHint: 'A team member has seen your request',
        receivedByAt: 'Received by {name} \u2014 {time}',
        shieldInProgress: 'In progress',
        shieldResolved: 'Resolved',
        resolvedByAt: 'Resolved by {name} \u2014 {time}',
        cancel: 'Cancel',
        errorTitle: 'Something went wrong',
        tryAgain: 'Try again',
        notAvailable: 'The guest assistance platform is not available right now.',
        welcomeTitle: 'Complete your welcome check-in',
        welcomeTag: 'Get Wi-Fi access and tell us about your arrival',
        messages: 'Your Hotel Messages',
        messagesTag: 'Messages and gifts from your hotel',
        communityBoard: 'Community Board',
        communityBoardTag: 'Notices from building management',
        acknowledge: 'Acknowledge',
        acknowledged: 'Acknowledged',
        activity: 'Activity',
        activityUnit: 'My Requests',
        activityTag: 'Your requests, orders and tips this stay',
        activityTagUnit: 'Your requests and updates',
        umTile: 'Unit Message', umTileUnit: 'Message a Neighbour', umTileHotel: 'Message a Guest',
        tapEntryTile: 'Tap Entry', tapEntryTag: 'Secure front-door access',
        vstTile: 'Visitors', vstTag: 'Conversations at your door', vstNew: 'new',
        vstTitle: 'Visitors', vstUnit: 'Unit', vstEmpty: 'No visitor has used your entry code yet.',
        vstActive: 'Active', vstEnded: 'Ended', vstBack: 'Back to visitors',
        vstVisitorAt: 'Visitor at', vstStarted: 'Arrived', vstNoMessages: 'No message yet',
        vstThreadEmpty: 'Nothing here yet. Write first if you like.',
        vstPlaceholder: 'Write to the visitor…', vstNotify: 'Notify visitor',
        vstNotified: 'Visitor notified', vstClosed: 'This visitor session has ended.',
        vstPrivacy: 'The visitor never sees your phone number or email.',
        vstYou: 'You', vstVisitor: 'Visitor', vstAutoReply: 'Auto-reply', vstChose: 'Chose:',
        vstAtDoorNow: 'At your door now', vstNotAtDoor: 'Not at the door',
        vstErr: 'Could not send. Please try again.',
        ppTile: 'People & Access', ppTag: 'Who can reach your door', ppTitle: 'People & Access', ppUnit: 'Unit',
        ppRoleMaster: 'Primary resident', ppRoleAdditional: 'Additional resident', ppYou: 'You',
        ppPeopleHdr: 'People in your unit', ppEmptyPeople: 'No one added yet.',
        ppAdd: 'Add a person', ppName: 'Full name', ppEmail: 'Email (optional)', ppPhone: 'Phone (optional)',
        ppSave: 'Save', ppCancel: 'Cancel', ppSaving: 'Saving…',
        ppCap: 'This unit already has the maximum of 3 people.', ppNotMaster: 'Only the primary resident can add people.',
        ppNameReq: 'Please enter a name.', ppErr: 'Something went wrong. Please try again.',
        smsTitle: 'Text me when someone is at my door', smsSendTo: 'Texts go to', smsNoPhone: 'No phone number on file — add one to receive texts.',
        ahTitle: 'Recent actions', ahEmpty: 'Nothing yet — your recent actions will appear here.',
        ahClearAll: 'Clear all', ahRemove: 'Remove from my list',
        ahFootnote: 'This is your own list. Removing an item never changes the record.',
        ahAcknowledge: 'Acknowledged', ahResolve: 'Resolved', ahCancel: 'Cancelled',
        smsOn: 'On', smsOff: 'Off', smsPauseTitle: 'Pause for', smsPause2h: '2 hours',
        smsPauseTomorrow: 'Until tomorrow 9:00', smsPause2d: '2 days',
        smsPausedUntil: 'Paused until {{when}}', smsResumeNow: 'Turn back on',
        ppActionsHdr: 'Your visitor actions', ppActionsSub: 'What a visitor can do at your door',
        ppEmptyActions: 'No actions yet.', ppAddAction: 'Add an action', ppActionType: 'Action',
        ppActionCap: 'You can have up to 10 actions.', ppComingSoon: 'Coming soon', ppOn: 'On', ppOff: 'Off',
        ppActionAdded: 'Action added.', ppPersonAdded: 'Person added.',
        ppNoteLabel: 'Note for visitors', ppNotePlaceholder: 'e.g. Leave packages with the concierge', ppAddNote: 'Add a note', ppEditNote: 'Edit',
        atCall: 'Call', atMessage: 'Message', atDeliveries: 'Deliveries', atMaintenance: 'Maintenance',
        atParking: 'Parking', atPickup: 'Pickup', atConcierge: 'Concierge', atImAway: "I'm away", atCustom: 'Custom instruction',

        annTile: 'Announcements', annTag: 'Notices from management', annTitle: 'Announcements', annEmpty: 'No announcements yet.', annFrom: 'From management', annAll: 'All Residents', annFloor: 'Floor {n}', umSeen: 'Seen', annPinned: 'Pinned', annAck: 'Acknowledge',
        homeReqTitle: 'Your requests', groupCommTile: 'Communication', groupCommTag: 'Notices & announcements', groupBuildingTile: 'Building & Access', groupBuildingTag: 'Entry, people & building', groupServicesTile: 'Services', groupServicesTag: 'Waste, parking & amenities', groupOptions: 'options', commUnitTag: 'Sent to your unit', commAllTag: 'Sent to all residents',
        umTag: 'Message another unit privately', umTagUnit: 'Message a neighbour privately',
        umTitle: 'Unit Messages', umStart: 'Start a message', umChooseUnit: 'Choose a unit',
        umNoUnits: 'No other units are available to message right now.',
        umRequests: 'Requests', umSent: 'Sent', umActive: 'Conversations', umClosed: 'Closed',
        umNone: 'No conversations yet. Tap “Start a message” to reach another unit.',
        umWaiting: 'Waiting for them to accept', umWantsToMessage: 'wants to message you',
        umAccept: 'Accept', umIgnore: 'Ignore', umClose: 'End conversation', umReopen: 'Reopen',
        umReopenHint: 'They will need to accept again.', umCooldown: 'This unit declined recently. You can try again later.',
        umClosedNote: 'This conversation has ended.', umNotActive: 'Accept the request to start chatting.',
        umMessagePlaceholder: 'Type a message', umFirstMessagePlaceholder: 'Add a short message (optional)', umPhotoHelper: 'Add a photo to your message (optional).',
        umSendRequest: 'Send request', umRequestSent: 'Request sent', umYou: 'You',
        umUnit: 'Unit', umRoom: 'Room', umError: 'Something went wrong. Please try again.',
        timeJustNow: 'Just now', timeMinAgo: '{n} min ago', timeHourAgo: '{n} hour ago', timeHoursAgo: '{n} hours ago', timeToday: 'Today', timeYesterday: 'Yesterday',
        statusOpen: 'Sent', statusHandling: 'Seen', statusResolved: 'Fixed', statusCancelled: 'Cancelled',
        reqStepSent: 'Sent', reqStepSeen: 'Seen', reqStepFixed: 'Fixed',
        reqProgressLegend: 'Request status: sent, then seen by staff, then fixed.',
        homeMore: 'More options',
        fullMenu: 'Full Menu',
        groupedMenu: 'Grouped',
        activityClear: 'Remove from my history',
        activityTitle: 'Your activity',
        activityEmpty: 'No activity yet during this stay.',
        activityNoCharge: 'No charge',
        activityTipWord: 'tip',
        activityDetailTitle: 'Activity detail',
        activityWhen: 'When',
        activityWho: 'Handled by',
        activityStatus: 'Status',
        activityAmount: 'Amount',
        activityNotYet: 'Not yet',
        offers: 'Offers & Gift Cards',
        offersTag: 'Special offers and gift cards for your stay',
        offersTitle: 'Offers & Gift Cards',
        offersEmpty: 'No offers available right now.',
        offerCode: 'Code',
        offerExpires: 'Expires',
        offerRedeemHint: 'Show this code to hotel staff to redeem.',
        poolTitle: 'Pool & Terrace',
        poolTag: 'Order without leaving your lounger',
        poolEmpty: 'No pool services available right now.',
        poolDrinks: 'Drinks',
        poolDrinksTag: 'Order drinks to your spot',
        poolFood: 'Food',
        poolFoodTag: 'Order food to your spot',
        poolTowels: 'Towels',
        poolTowelsTag: 'Request fresh pool towels',
        poolTowelsBody: 'We\u2019ll bring fresh pool towels to you.',
        poolOther: 'Other Pool Service',
        poolOtherTag: 'Ask for anything else',
        poolOtherLabel: 'How can we help?',
        poolOtherPlaceholder: 'Tell us what you need\u2026',
        poolMenuLabel: 'Menu',
        poolOrderLabel: 'What would you like?',
        poolOrderPlaceholder: 'e.g. 2 mojitos, 1 club sandwich',
        poolLocationLabel: 'Sun-lounger / table (optional)',
        poolLocationPlaceholder: 'e.g. lounger 12, cabana 3',
        poolSentTitle: 'Order received',
        poolSentBody: 'Our team is on it. Track progress below.',
        poolCat: { drinks: 'Drinks', food: 'Food', towels: 'Towels', other: 'Other Pool Service' },
        poolTowelsOther: 'Towels / Other Service', poolTowelsOtherTag: 'Towels, reading & more',
        poolSecurityMedical: 'Security / Medical', poolSecurityMedicalTag: 'Urgent assistance',
        poolFullMenu: 'Full Guest Menu',
        poolMagazine: 'Magazine / Reading Material', poolOtherSvc: 'Other Service',
        poolTowelsQty: 'How many towels?', poolNotes: 'Additional notes',
        poolContinueFood: 'Continue to Food Menu', poolContinueDrink: 'Continue to Drink Menu',
        poolReview: 'Review Order', poolConfirmPlace: 'Confirm & Place Order', poolYourOrder: 'Your order',
        poolPinPrompt: 'Enter your 4-digit passcode', poolPinError: 'Invalid passcode',
        poolSecurity: 'Security', poolMedical: 'Medical',
        poolSecurityDesc: 'Urgent security assistance', poolMedicalDesc: 'Medical assistance',
        poolChoose: 'Choose the type of assistance',
        noMessages: 'No messages yet.',
        hotelMessage: 'Message from your hotel',
        voucherGift: 'A gift for you',
        viewVoucher: 'View your voucher',
        voucherRedeemed: 'This gift has been redeemed. Enjoy!',
        voucherExpires: 'Valid until',
        opensNewTab: 'Opens in a new tab \u2014 your session here stays active.',
        // Security
        security: 'Security',
        securityTag: 'Immediate assistance, any time',
        urgentButton: 'URGENT \u2014 Send Security Now',
        urgentConfirmTitle: 'Send urgent security alert?',
        urgentConfirmBody: 'The security team will be notified immediately with your room number.',
        confirmSend: 'Yes, send now',
        urgentSentTitle: 'Security has been alerted',
        urgentSentBody: 'Your room number and the time were sent to the security team.',
        standardTitle: 'Report a concern',
        selectCategory: 'What is this about?',
        detailsOptional: 'Details (optional)',
        detailsPlaceholder: 'Tell us what is happening\u2026',
        securitySentTitle: 'Request sent',
        securitySentBody: 'The security team has been notified.',
        secCat: {
            noisy_neighbour: 'Noisy neighbour',
            hallway_disturbance: 'Hallway disturbance',
            suspicious_activity: 'Suspicious activity',
            guest_visitor_issue: 'Guest / visitor issue',
            room_security_concern: 'Room security concern',
            other: 'Other',
        },
        // Hotel info
        hotelInfo: 'Hotel Information',
        hotelInfoTag: 'Hours, amenities and services',
        hours: 'Hours',
        moreInfo: 'More info',
        // Food
        food: 'Food & Dining',
        foodTag: 'Restaurant, room service and nearby options',
        hotelRestaurant: 'Hotel Restaurant',
        roomService: 'Room Service',
        viewMenu: 'View menu',
        partners: 'Nearby partner restaurants',
        visitSite: 'Visit website',
        restaurants: 'Restaurants',
        reserve: 'Reserve a table',
        giftCards: 'Gift cards available',
        backToApp: 'Back to YULONTAP',
        welcomeBack: 'Welcome back',
        notYou: 'Not {name}?',
        firstName: 'First name',
        stayHowLong: 'How long are you staying?',
        day: 'day',
        days: 'days',
        otherStay: 'Other / longer stay',
        daysPlaceholder: 'Number of days',
        pinCreateTitle: 'CREATE YOUR 4-DIGIT PIN',
        pinLabel: 'Choose 4 digits',
        pinHint: 'You create this PIN yourself — the hotel does not provide it. It confirms purchases and tips you make through the hotel.',
        nameRequired: 'Please enter your first name.',
        daysRequired: 'Please choose how long you are staying.',
        pinRequired: 'Please choose a 4-digit PIN.',
        residentIdentifyHint: 'Enter your unit and your name.',
        pinEnterTitle: 'ENTER YOUR 4-DIGIT PIN',
        residentPinCreateHint: 'Create a permanent 4-digit PIN. You will use it every time you access your building.',
        residentPinEnterHint: 'Enter the PIN you created.',
        residentNotVerified: "We couldn't verify your unit and name. Please contact building management.",
        tipRoomService: 'Tip room service',
        priorityBadge: 'Priority',
        priorityHeading: 'Important message from your hotel',
        priorityAck: 'I\u2019ve read this \u2014 Continue',
        priorityMore: 'One more important message follows',
        valet: 'Valet Parking',
        valetTag: 'Request your vehicle',
        bringMyCar: 'Bring my car',
        valetWhen: 'When would you like your vehicle?',
        now: 'Now',
        in15: 'In 15 minutes',
        in30: 'In 30 minutes',
        in1h: 'In 1 hour',
        in2h: 'In 2 hours',
        untilTime: 'At a specific time',
        guestName: 'Guest name',
        vehicleMake: 'Make',
        vehicleModel: 'Model',
        vehicleColor: 'Color',
        vehiclePlate: 'License plate',
        valetOptionalHint: 'Color and plate are optional \u2014 they help us identify your vehicle faster.',
        valetSubmit: 'Request my vehicle',
        valetSentTitle: 'Your vehicle has been requested',
        valetSentBody: 'Requested for',
        valetTicket: 'Your valet ticket',
        valetRequestedFor: 'Requested for',
        valetAnother: 'Request another vehicle',
        valetError: 'Something went wrong \u2014 please try again.',
        valet_retrieval_requested: 'Requested',
        valet_retrieving: 'Being retrieved',
        valet_ready: 'Ready at the entrance',
        valet_delivered: 'Delivered',
        valet_cancelled: 'Cancelled',
        tipHousekeeping: 'Tip housekeeping',
        tipConcierge: 'Tip concierge',
        tipValet: 'Tip valet',
        tipSoon: 'Secure tipping is being activated by the hotel \u2014 available very soon.',
        tipHowMuch: 'How much would you like to tip?',
        tipOtherAmount: 'Other amount',
        tipAmountPlaceholder: 'Amount ($)',
        tipSend: 'Send tip',
        tipThanksTitle: 'Thank you!',
        tipThanksBody: 'Your {amount} tip for {recipient} has been registered with the hotel.',
        tipError: 'We could not register your tip \u2014 please try again.',
        tipRecipient: {
            concierge: 'the concierge team',
            housekeeping: 'the housekeeping team',
            valet: 'the valet team',
            room_service: 'room service',
        },
        destChecking: 'Opening\u2026',
        destExternalNote: 'This official website opens in your browser. Your session here stays active \u2014 simply come back to this tab.',
        destOpenSite: 'Open official website',
        destOpened: 'The website opened in a new tab. Come back here anytime \u2014 no need to scan again.',
        // Entertainment
        entertainment: 'Entertainment',
        entertainmentTag: 'In-room entertainment',
        entEvents: 'Events',
        entMovies: 'Movies',
        entPlaces: 'Local Places',
        entPartners: 'Restaurants',
        entPartnerVisit: 'Visit',
        entPartnersNote: 'Partner restaurants — each link opens the restaurant\u2019s own website.',
        entMoviesSub: 'Movies & showtimes nearby',
        entShowtimes: 'What\u2019s Showing & Showtimes',
        entTickets: 'Details & Tickets',
        entLoading: 'Finding what\u2019s on nearby\u2026',
        entNoEvents: 'No events found nearby for this filter. Try another one.',
        entUnavailable: 'Live events are temporarily unavailable. Please check back soon.',
        fToday: 'Today',
        fTonight: 'Tonight',
        fWeekend: 'This Weekend',
        fWeek: 'Next 7 Days',
        fComingUp: 'Coming Up',
        cAll: 'All',
        cMusic: 'Music',
        cSports: 'Sports',
        cTheatre: 'Theatre',
        cFamily: 'Family',
        cat_cinema: 'Cinema',
        cat_theatre: 'Theatre',
        cat_museum: 'Museum',
        cat_attraction: 'Attraction',
        cat_venue: 'Venue',
        cat_festival: 'Festival',
        cat_tourism: 'Tourism',
        cat_convention: 'Convention centre',
        cat_sports: 'Sports venue',
        cat_nightlife: 'Nightlife',
        cat_family: 'Family',
        cat_other: 'Local place',
        // Housekeeping
        housekeeping: 'Housekeeping',
        housekeepingTag: 'Cleaning, supplies and more',
        dndTitle: 'Do Not Disturb',
        dndBody: 'Tell housekeeping not to service your room before:',
        dndConfirm: 'Set Do Not Disturb',
        dndSetTitle: 'Do Not Disturb set',
        dndSetBody: 'Housekeeping will not disturb your room before',
        dndTomorrow: 'tomorrow morning',
        dndAtTimes: { '09:00': '9:00 AM', '10:00': '10:00 AM', '11:00': '11:00 AM' },
        // Concierge
        concierge: 'Concierge',
        conciergeTag: 'Towels, pillows \u2014 anything you need',
        conciergeTitle: 'What do you need?',
        conMessage: 'Your message',
        conMessagePlaceholder: 'e.g. Two extra towels please',
        conMessageRequired: 'Please tell us what you need.',
        conSentTitle: 'Request received',
        conSentBody: 'Our team has been notified and will take care of it.',
        conCat: {
            housekeeping: 'Housekeeping',
            towels: 'Towels',
            soap: 'Soap / toiletries',
            pillows: 'Pillows',
            iron: 'Iron',
            luggage: 'Luggage help',
            missing_item: 'Missing item',
            other: 'Other',
        },
    },
    fr: {
        title: "Plateforme d'assistance aux clients",
        submit: 'Envoyer', requestSent: 'Demande envoy\u00e9e',
        detailsPlaceholder: 'Ajouter des d\u00e9tails (facultatif)',
        propertyPhotoHelper: 'Ajoutez une photo pour nous aider \u00e0 comprendre le probl\u00e8me (facultatif).',
        room: 'Chambre',
        roomTitle: 'Quel est le num\u00e9ro de votre chambre ?',
        roomHint: 'Votre num\u00e9ro de chambre nous permet de diriger vos demandes vers la bonne \u00e9quipe.',
        roomPlaceholder: 'Num\u00e9ro de chambre',
        continue: 'Continuer',
        roomNotFound: "Nous n'avons pas trouv\u00e9 cette chambre. V\u00e9rifiez le num\u00e9ro.",
        roomInvalid: 'Veuillez entrer un num\u00e9ro de chambre valide.',
        demoRoomFormat: 'Dans cette d\u00e9mo, entrez n\u2019importe quel num\u00e9ro de chambre ou d\u2019unit\u00e9 \u00e0 3 chiffres (par exemple 214).',
        demoPinFormat: 'Dans cette d\u00e9mo, entrez n\u2019importe quel code \u00e0 4 chiffres (par exemple 1234).',
        demoGuestCta: 'Continuer comme client de d\u00e9monstration (chambre {room})',
        demoTenantCta: 'Continuer comme locataire de d\u00e9monstration (unit\u00e9 {unit})',
        demoTenantHint: 'Ou inscrivez-vous ci-dessus, comme un vrai r\u00e9sident.',
        demoGuestHint: 'Ou inscrivez-vous ci-dessus, comme un vrai client.',
        sessionExpired: 'Votre session a expir\u00e9. Veuillez confirmer votre chambre \u00e0 nouveau.',
        menuTitle: 'Comment pouvons-nous vous aider ?',
        changeRoom: 'Changer de chambre',
        residentAssistTitle: 'Portail de communication',
        roomTitleUnit: 'Quel est le num\u00e9ro de votre unit\u00e9\u00a0?',
        roomHintUnit: 'Votre num\u00e9ro d\u2019unit\u00e9 nous permet de diriger vos demandes vers la bonne \u00e9quipe.',
        roomPlaceholderUnit: 'Num\u00e9ro d\u2019unit\u00e9',
        changeUnit: 'Changer d\u2019unit\u00e9',
        sessionLength: 'Rester connect\u00e9 pendant',
        back: 'Retour',
        done: 'Termin\u00e9',
        send: 'Envoyer la demande',
        sending: 'Envoi\u2026',
        requestProgress: 'Progression de la demande',
        shieldSent: 'Envoy\u00e9e',
        shieldPending: 'En attente',
        shieldReceived: 'Re\u00e7ue',
        shieldCompleted: 'Termin\u00e9e',
        shieldCancelled: 'Annul\u00e9e',
        shieldSentHint: 'Votre demande a \u00e9t\u00e9 envoy\u00e9e',
        shieldPendingHint: "En attente de prise en charge par l'\u00e9quipe",
        shieldReceivedHint: "Un membre de l'\u00e9quipe a vu votre demande",
        receivedByAt: 'Re\u00e7ue par {name} \u2014 {time}',
        shieldInProgress: 'En cours',
        shieldResolved: 'R\u00e9solue',
        resolvedByAt: 'R\u00e9solue par {name} \u2014 {time}',
        cancel: 'Annuler',
        errorTitle: 'Une erreur est survenue',
        tryAgain: 'R\u00e9essayer',
        notAvailable: "La plateforme d'assistance aux clients n'est pas disponible pour le moment.",
        welcomeTitle: 'Compl\u00e9tez votre enregistrement de bienvenue',
        welcomeTag: 'Obtenez le Wi-Fi et dites-nous comment s\u2019est pass\u00e9e votre arriv\u00e9e',
        messages: 'Vos messages de l\u2019h\u00f4tel',
        messagesTag: 'Messages et cadeaux de votre h\u00f4tel',
        communityBoard: 'Babillard communautaire',
        communityBoardTag: 'Avis de la gestion de l\u2019immeuble',
        acknowledge: 'Confirmer la lecture',
        acknowledged: 'Lu et confirm\u00e9',
        activity: 'Activit\u00e9',
        activityUnit: 'Mes demandes',
        activityTag: 'Vos demandes, commandes et pourboires de ce s\u00e9jour',
        activityTagUnit: 'Vos demandes et mises \u00e0 jour',
        umTile: 'Message d\u2019unit\u00e9', umTileUnit: 'Message \u00e0 un voisin', umTileHotel: 'Message \u00e0 un client',
        tapEntryTile: 'Entr\u00e9e Tap', tapEntryTag: 'Acc\u00e8s s\u00e9curis\u00e9 \u00e0 la porte',
        vstTile: 'Visiteurs', vstTag: 'Conversations à votre porte', vstNew: 'nouveau(x)',
        vstTitle: 'Visiteurs', vstUnit: 'Unité', vstEmpty: 'Aucun visiteur n\u2019a encore utilisé votre code d\u2019entrée.',
        vstActive: 'Active', vstEnded: 'Terminée', vstBack: 'Retour aux visiteurs',
        vstVisitorAt: 'Visiteur à', vstStarted: 'Arrivé', vstNoMessages: 'Aucun message',
        vstThreadEmpty: 'Rien pour le moment. Écrivez le premier si vous le souhaitez.',
        vstPlaceholder: 'Écrire au visiteur…', vstNotify: 'Aviser le visiteur',
        vstNotified: 'Visiteur avisé', vstClosed: 'Cette session de visiteur est terminée.',
        vstPrivacy: 'Le visiteur ne voit jamais votre numéro ni votre courriel.',
        vstYou: 'Vous', vstVisitor: 'Visiteur', vstAutoReply: 'Réponse automatique', vstChose: 'A choisi :',
        vstAtDoorNow: 'À votre porte maintenant', vstNotAtDoor: 'Pas à la porte',
        vstErr: 'Envoi impossible. Veuillez réessayer.',
        ppTile: 'Personnes et acc\u00e8s', ppTag: 'Qui peut vous joindre \u00e0 la porte', ppTitle: 'Personnes et acc\u00e8s', ppUnit: 'Unit\u00e9',
        ppRoleMaster: 'R\u00e9sident principal', ppRoleAdditional: 'R\u00e9sident suppl\u00e9mentaire', ppYou: 'Vous',
        ppPeopleHdr: 'Personnes de votre unit\u00e9', ppEmptyPeople: 'Personne n\u2019a encore \u00e9t\u00e9 ajout\u00e9.',
        ppAdd: 'Ajouter une personne', ppName: 'Nom complet', ppEmail: 'Courriel (facultatif)', ppPhone: 'T\u00e9l\u00e9phone (facultatif)',
        ppSave: 'Enregistrer', ppCancel: 'Annuler', ppSaving: 'Enregistrement\u2026',
        ppCap: 'Cette unit\u00e9 a d\u00e9j\u00e0 le maximum de 3 personnes.', ppNotMaster: 'Seul le r\u00e9sident principal peut ajouter des personnes.',
        ppNameReq: 'Veuillez saisir un nom.', ppErr: 'Une erreur est survenue. Veuillez r\u00e9essayer.',
        smsTitle: 'M\u2019envoyer un texto quand quelqu\u2019un est \u00e0 ma porte', smsSendTo: 'Textos envoy\u00e9s au', smsNoPhone: 'Aucun num\u00e9ro au dossier \u2014 ajoutez-en un pour recevoir des textos.',
        ahTitle: 'Actions récentes', ahEmpty: 'Rien pour le moment — vos actions récentes appara\u00eetront ici.',
        ahClearAll: 'Tout effacer', ahRemove: 'Retirer de ma liste',
        ahFootnote: 'Ceci est votre liste personnelle. Retirer un élément ne modifie jamais le dossier.',
        ahAcknowledge: 'Prise en charge', ahResolve: 'Résolue', ahCancel: 'Annulée',
        smsOn: 'Activ\u00e9', smsOff: 'D\u00e9sactiv\u00e9', smsPauseTitle: 'Mettre en pause', smsPause2h: '2 heures',
        smsPauseTomorrow: 'Jusqu\u2019\u00e0 demain 9 h', smsPause2d: '2 jours',
        smsPausedUntil: 'En pause jusqu\u2019\u00e0 {{when}}', smsResumeNow: 'R\u00e9activer',
        ppActionsHdr: 'Vos actions pour les visiteurs', ppActionsSub: 'Ce qu\u2019un visiteur peut faire \u00e0 votre porte',
        ppEmptyActions: 'Aucune action pour le moment.', ppAddAction: 'Ajouter une action', ppActionType: 'Action',
        ppActionCap: 'Vous pouvez avoir jusqu\u2019\u00e0 10 actions.', ppComingSoon: 'Bient\u00f4t disponible', ppOn: 'Activ\u00e9', ppOff: 'D\u00e9sactiv\u00e9',
        ppActionAdded: 'Action ajout\u00e9e.', ppPersonAdded: 'Personne ajout\u00e9e.',
        ppNoteLabel: 'Note pour les visiteurs', ppNotePlaceholder: 'ex. Laissez les colis \u00e0 la conciergerie', ppAddNote: 'Ajouter une note', ppEditNote: 'Modifier',
        atCall: 'Appel', atMessage: 'Message', atDeliveries: 'Livraisons', atMaintenance: 'Entretien',
        atParking: 'Stationnement', atPickup: 'Ramassage', atConcierge: 'Conciergerie', atImAway: 'Je suis absent', atCustom: 'Instruction personnalis\u00e9e',

        annTile: 'Annonces', annTag: 'Avis de la gestion', annTitle: 'Annonces', annEmpty: 'Aucune annonce pour le moment.', annFrom: 'De la gestion', annAll: 'Tous les r\u00e9sidents', annFloor: '\u00c9tage {n}', umSeen: 'Vu', annPinned: '\u00c9pingl\u00e9e', annAck: 'Confirmer',
        homeReqTitle: 'Vos demandes', groupCommTile: 'Communication', groupCommTag: 'Avis et annonces', groupBuildingTile: 'Immeuble et accès', groupBuildingTag: 'Entrée, personnes et immeuble', groupServicesTile: 'Services', groupServicesTag: 'Déchets, stationnement et commodités', groupOptions: 'options', commUnitTag: 'Envoyé à votre unité', commAllTag: 'Envoyé à tous les résidents',
        umTag: 'Contactez une autre unit\u00e9 en priv\u00e9', umTagUnit: 'Contactez un voisin en priv\u00e9',
        umTitle: 'Messages d\u2019unit\u00e9', umStart: 'D\u00e9marrer un message', umChooseUnit: 'Choisir une unit\u00e9',
        umNoUnits: 'Aucune autre unit\u00e9 n\u2019est disponible pour le moment.',
        umRequests: 'Demandes', umSent: 'Envoy\u00e9es', umActive: 'Conversations', umClosed: 'Termin\u00e9es',
        umNone: 'Aucune conversation. Touchez \u00ab D\u00e9marrer un message \u00bb pour joindre une autre unit\u00e9.',
        umWaiting: 'En attente de leur acceptation', umWantsToMessage: 'souhaite vous \u00e9crire',
        umAccept: 'Accepter', umIgnore: 'Ignorer', umClose: 'Terminer la conversation', umReopen: 'Rouvrir',
        umReopenHint: 'Ils devront accepter \u00e0 nouveau.', umCooldown: 'Cette unit\u00e9 a refus\u00e9 r\u00e9cemment. R\u00e9essayez plus tard.',
        umClosedNote: 'Cette conversation est termin\u00e9e.', umNotActive: 'Acceptez la demande pour commencer \u00e0 discuter.',
        umMessagePlaceholder: '\u00c9crire un message', umFirstMessagePlaceholder: 'Ajouter un court message (facultatif)', umPhotoHelper: 'Ajoutez une photo \u00e0 votre message (facultatif).',
        umSendRequest: 'Envoyer la demande', umRequestSent: 'Demande envoy\u00e9e', umYou: 'Vous',
        umUnit: 'Unit\u00e9', umRoom: 'Chambre', umError: 'Une erreur est survenue. Veuillez r\u00e9essayer.',
        timeJustNow: '\u00c0 l\u2019instant', timeMinAgo: 'il y a {n} min', timeHourAgo: 'il y a {n} h', timeHoursAgo: 'il y a {n} h', timeToday: 'Aujourd\u2019hui', timeYesterday: 'Hier',
        statusOpen: 'Envoyée', statusHandling: 'Vue', statusResolved: 'Réglée', statusCancelled: 'Annulée',
        reqStepSent: 'Envoyée', reqStepSeen: 'Vue', reqStepFixed: 'Réglée',
        reqProgressLegend: 'État d’une demande : envoyée, puis vue par l’équipe, puis réglée.',
        homeMore: 'Plus d’options',
        fullMenu: 'Menu complet',
        groupedMenu: 'Groupé',
        activityClear: 'Retirer de mon historique',
        activityTitle: 'Votre activit\u00e9',
        activityEmpty: 'Aucune activit\u00e9 pour le moment durant ce s\u00e9jour.',
        activityNoCharge: 'Sans frais',
        activityTipWord: 'pourboire',
        activityDetailTitle: "D\u00e9tail de l'activit\u00e9",
        activityWhen: 'Quand',
        activityWho: 'Trait\u00e9e par',
        activityStatus: 'Statut',
        activityAmount: 'Montant',
        activityNotYet: 'Pas encore',
        offers: 'Offres et cartes-cadeaux',
        offersTag: 'Offres sp\u00e9ciales et cartes-cadeaux pour votre s\u00e9jour',
        offersTitle: 'Offres et cartes-cadeaux',
        offersEmpty: 'Aucune offre disponible pour le moment.',
        offerCode: 'Code',
        offerExpires: 'Expire le',
        offerRedeemHint: "Pr\u00e9sentez ce code au personnel de l'h\u00f4tel pour l'utiliser.",
        poolTitle: 'Piscine & Terrasse',
        poolTag: 'Commandez sans quitter votre transat',
        poolEmpty: 'Aucun service piscine disponible pour le moment.',
        poolDrinks: 'Boissons',
        poolDrinksTag: 'Commandez des boissons \u00e0 votre place',
        poolFood: 'Nourriture',
        poolFoodTag: 'Commandez \u00e0 manger \u00e0 votre place',
        poolTowels: 'Serviettes',
        poolTowelsTag: 'Demandez des serviettes de piscine',
        poolTowelsBody: 'Nous vous apportons des serviettes de piscine fra\u00eeches.',
        poolOther: 'Autre service piscine',
        poolOtherTag: 'Demandez autre chose',
        poolOtherLabel: 'Comment pouvons-nous vous aider ?',
        poolOtherPlaceholder: 'Dites-nous ce dont vous avez besoin\u2026',
        poolMenuLabel: 'Menu',
        poolOrderLabel: 'Que d\u00e9sirez-vous ?',
        poolOrderPlaceholder: 'ex. 2 mojitos, 1 club sandwich',
        poolLocationLabel: 'Transat / table (facultatif)',
        poolLocationPlaceholder: 'ex. transat 12, cabane 3',
        poolSentTitle: 'Commande re\u00e7ue',
        poolSentBody: 'Notre \u00e9quipe s\u2019en occupe. Suivez l\u2019avancement ci-dessous.',
        poolCat: { drinks: 'Boissons', food: 'Nourriture', towels: 'Serviettes', other: 'Autre service piscine' },
        poolTowelsOther: 'Serviettes / Autre service', poolTowelsOtherTag: 'Serviettes, magazines et plus',
        poolSecurityMedical: 'Sécurité / Médical', poolSecurityMedicalTag: 'Assistance urgente',
        poolFullMenu: 'Menu complet de l\u2019hôtel',
        poolMagazine: 'Magazine / Lecture', poolOtherSvc: 'Autre service',
        poolTowelsQty: 'Combien de serviettes ?', poolNotes: 'Notes complémentaires',
        poolContinueFood: 'Continuer vers le menu nourriture', poolContinueDrink: 'Continuer vers le menu boissons',
        poolReview: 'Vérifier la commande', poolConfirmPlace: 'Confirmer et envoyer', poolYourOrder: 'Votre commande',
        poolPinPrompt: 'Saisissez votre code à 4 chiffres', poolPinError: 'Code invalide',
        poolSecurity: 'Sécurité', poolMedical: 'Médical',
        poolSecurityDesc: 'Assistance de sécurité urgente', poolMedicalDesc: 'Assistance médicale',
        poolChoose: 'Choisissez le type d\u2019assistance',
        noMessages: 'Aucun message pour le moment.',
        hotelMessage: 'Message de votre h\u00f4tel',
        voucherGift: 'Un cadeau pour vous',
        viewVoucher: 'Voir votre bon-cadeau',
        voucherRedeemed: 'Ce cadeau a \u00e9t\u00e9 utilis\u00e9. Profitez-en !',
        voucherExpires: 'Valide jusqu\u2019au',
        opensNewTab: 'S\u2019ouvre dans un nouvel onglet \u2014 votre session ici reste active.',
        security: 'S\u00e9curit\u00e9',
        securityTag: 'Assistance imm\u00e9diate, en tout temps',
        urgentButton: 'URGENT \u2014 Alerter la s\u00e9curit\u00e9',
        urgentConfirmTitle: 'Envoyer une alerte de s\u00e9curit\u00e9 urgente ?',
        urgentConfirmBody: "L'\u00e9quipe de s\u00e9curit\u00e9 sera avis\u00e9e imm\u00e9diatement avec votre num\u00e9ro de chambre.",
        confirmSend: 'Oui, envoyer maintenant',
        urgentSentTitle: 'La s\u00e9curit\u00e9 a \u00e9t\u00e9 alert\u00e9e',
        urgentSentBody: "Votre num\u00e9ro de chambre et l'heure ont \u00e9t\u00e9 transmis \u00e0 l'\u00e9quipe de s\u00e9curit\u00e9.",
        standardTitle: 'Signaler un probl\u00e8me',
        selectCategory: 'De quoi s\u2019agit-il ?',
        detailsOptional: 'D\u00e9tails (facultatif)',
        detailsPlaceholder: 'Dites-nous ce qui se passe\u2026',
        securitySentTitle: 'Demande envoy\u00e9e',
        securitySentBody: "L'\u00e9quipe de s\u00e9curit\u00e9 a \u00e9t\u00e9 avis\u00e9e.",
        secCat: {
            noisy_neighbour: 'Voisin bruyant',
            hallway_disturbance: 'D\u00e9rangement dans le couloir',
            suspicious_activity: 'Activit\u00e9 suspecte',
            guest_visitor_issue: 'Probl\u00e8me client / visiteur',
            room_security_concern: 'S\u00e9curit\u00e9 de la chambre',
            other: 'Autre',
        },
        hotelInfo: "Informations sur l'h\u00f4tel",
        hotelInfoTag: 'Horaires, commodit\u00e9s et services',
        hours: 'Horaires',
        moreInfo: 'Plus d\u2019infos',
        food: 'Restauration',
        foodTag: 'Restaurant, service aux chambres et options \u00e0 proximit\u00e9',
        hotelRestaurant: "Restaurant de l'h\u00f4tel",
        roomService: 'Service aux chambres',
        viewMenu: 'Voir le menu',
        partners: 'Restaurants partenaires \u00e0 proximit\u00e9',
        visitSite: 'Visiter le site web',
        restaurants: 'Restaurants',
        reserve: 'R\u00e9server une table',
        giftCards: 'Cartes-cadeaux offertes',
        backToApp: 'Retour \u00e0 YULONTAP',
        welcomeBack: 'Bon retour',
        notYou: 'Pas {name}\u00a0?',
        firstName: 'Pr\u00e9nom',
        stayHowLong: 'Combien de temps restez-vous\u00a0?',
        day: 'jour',
        days: 'jours',
        otherStay: 'Autre / s\u00e9jour prolong\u00e9',
        daysPlaceholder: 'Nombre de jours',
        pinCreateTitle: 'CR\u00c9EZ VOTRE NIP \u00c0 4 CHIFFRES',
        pinLabel: 'Choisissez 4 chiffres',
        pinHint: 'Vous cr\u00e9ez ce NIP vous-m\u00eame \u2014 l\u2019h\u00f4tel ne le fournit pas. Il confirme vos achats et pourboires aupr\u00e8s de l\u2019h\u00f4tel.',
        nameRequired: 'Veuillez entrer votre pr\u00e9nom.',
        daysRequired: 'Veuillez choisir la dur\u00e9e de votre s\u00e9jour.',
        pinRequired: 'Veuillez choisir un NIP \u00e0 4 chiffres.',
        residentIdentifyHint: 'Entrez votre unit\u00e9 et votre nom.',
        pinEnterTitle: 'ENTREZ VOTRE NIP \u00c0 4 CHIFFRES',
        residentPinCreateHint: 'Cr\u00e9ez un NIP permanent \u00e0 4 chiffres. Vous l\u2019utiliserez chaque fois que vous acc\u00e9dez \u00e0 votre immeuble.',
        residentPinEnterHint: 'Entrez le NIP que vous avez cr\u00e9\u00e9.',
        residentNotVerified: "Nous n'avons pas pu v\u00e9rifier votre unit\u00e9 et votre nom. Veuillez contacter la gestion de l'immeuble.",
        tipRoomService: 'Pourboire \u2014 service aux chambres',
        priorityBadge: 'Prioritaire',
        priorityHeading: 'Message important de votre h\u00f4tel',
        priorityAck: 'J\u2019ai lu ce message \u2014 Continuer',
        priorityMore: 'Un autre message important suit',
        valet: 'Voiturier',
        valetTag: 'Demandez votre v\u00e9hicule',
        bringMyCar: 'Amenez ma voiture',
        valetWhen: 'Quand souhaitez-vous votre v\u00e9hicule\u00a0?',
        now: 'Maintenant',
        in15: 'Dans 15 minutes',
        in30: 'Dans 30 minutes',
        in1h: 'Dans 1 heure',
        in2h: 'Dans 2 heures',
        untilTime: '\u00c0 une heure pr\u00e9cise',
        guestName: 'Nom du client',
        vehicleMake: 'Marque',
        vehicleModel: 'Mod\u00e8le',
        vehicleColor: 'Couleur',
        vehiclePlate: 'Plaque d\u2019immatriculation',
        valetOptionalHint: 'La couleur et la plaque sont facultatives \u2014 elles nous aident \u00e0 identifier votre v\u00e9hicule plus vite.',
        valetSubmit: 'Demander mon v\u00e9hicule',
        valetSentTitle: 'Votre v\u00e9hicule a \u00e9t\u00e9 demand\u00e9',
        valetSentBody: 'Demand\u00e9 pour',
        valetTicket: 'Votre billet de voiturier',
        valetRequestedFor: 'Demand\u00e9 pour',
        valetAnother: 'Demander un autre v\u00e9hicule',
        valetError: 'Une erreur est survenue \u2014 veuillez r\u00e9essayer.',
        valet_retrieval_requested: 'Demand\u00e9',
        valet_retrieving: 'En cours de r\u00e9cup\u00e9ration',
        valet_ready: 'Pr\u00eat \u00e0 l\u2019entr\u00e9e',
        valet_delivered: 'Livr\u00e9',
        valet_cancelled: 'Annul\u00e9',
        tipHousekeeping: 'Pourboire \u2014 entretien m\u00e9nager',
        tipConcierge: 'Pourboire \u2014 conciergerie',
        tipValet: 'Pourboire \u2014 voiturier',
        tipSoon: 'Le pourboire s\u00e9curis\u00e9 est en cours d\u2019activation par l\u2019h\u00f4tel \u2014 disponible tr\u00e8s bient\u00f4t.',
        tipHowMuch: 'Quel montant souhaitez-vous donner\u00a0?',
        tipOtherAmount: 'Autre montant',
        tipAmountPlaceholder: 'Montant ($)',
        tipSend: 'Envoyer le pourboire',
        tipThanksTitle: 'Merci\u00a0!',
        tipThanksBody: 'Votre pourboire de {amount} pour {recipient} a \u00e9t\u00e9 enregistr\u00e9 aupr\u00e8s de l\u2019h\u00f4tel.',
        tipError: 'Impossible d\u2019enregistrer votre pourboire \u2014 veuillez r\u00e9essayer.',
        tipRecipient: {
            concierge: 'l\u2019\u00e9quipe de conciergerie',
            housekeeping: 'l\u2019\u00e9quipe d\u2019entretien m\u00e9nager',
            valet: 'l\u2019\u00e9quipe du voiturier',
            room_service: 'le service aux chambres',
        },
        destChecking: 'Ouverture\u2026',
        destExternalNote: 'Ce site officiel s\u2019ouvre dans votre navigateur. Votre session ici reste active \u2014 revenez simplement \u00e0 cet onglet.',
        destOpenSite: 'Ouvrir le site officiel',
        destOpened: 'Le site s\u2019est ouvert dans un nouvel onglet. Revenez ici \u00e0 tout moment \u2014 pas besoin de rescanner.',
        entertainment: 'Divertissement',
        entertainmentTag: 'Divertissement en chambre',
        entEvents: '\u00c9v\u00e9nements',
        entMovies: 'Cin\u00e9ma',
        entPlaces: 'Endroits locaux',
        entPartners: 'Restaurants',
        entPartnerVisit: 'Visiter',
        entPartnersNote: 'Restaurants partenaires \u2014 chaque lien ouvre le site Web du restaurant.',
        entMoviesSub: 'Films et horaires \u00e0 proximit\u00e9',
        entShowtimes: '\u00c0 l\u2019affiche et horaires',
        entTickets: 'D\u00e9tails et billets',
        entLoading: 'Recherche des activit\u00e9s \u00e0 proximit\u00e9\u2026',
        entNoEvents: 'Aucun \u00e9v\u00e9nement trouv\u00e9 \u00e0 proximit\u00e9 pour ce filtre. Essayez-en un autre.',
        entUnavailable: 'Les \u00e9v\u00e9nements en direct sont temporairement indisponibles. Revenez bient\u00f4t.',
        fToday: 'Aujourd\u2019hui',
        fTonight: 'Ce soir',
        fWeekend: 'Ce week-end',
        fWeek: '7 prochains jours',
        fComingUp: '\u00c0 venir',
        cAll: 'Tous',
        cMusic: 'Musique',
        cSports: 'Sports',
        cTheatre: 'Th\u00e9\u00e2tre',
        cFamily: 'Famille',
        cat_cinema: 'Cin\u00e9ma',
        cat_theatre: 'Th\u00e9\u00e2tre',
        cat_museum: 'Mus\u00e9e',
        cat_attraction: 'Attraction',
        cat_venue: 'Salle de spectacle',
        cat_festival: 'Festival',
        cat_tourism: 'Tourisme',
        cat_convention: 'Centre des congr\u00e8s',
        cat_sports: 'Site sportif',
        cat_nightlife: 'Vie nocturne',
        cat_family: 'Famille',
        cat_other: 'Endroit local',
        housekeeping: 'Entretien m\u00e9nager',
        housekeepingTag: 'Nettoyage, fournitures et plus',
        dndTitle: 'Ne pas d\u00e9ranger',
        dndBody: "Indiquez \u00e0 l'entretien m\u00e9nager de ne pas passer avant :",
        dndConfirm: 'Activer Ne pas d\u00e9ranger',
        dndSetTitle: 'Ne pas d\u00e9ranger activ\u00e9',
        dndSetBody: "L'entretien m\u00e9nager ne vous d\u00e9rangera pas avant",
        dndTomorrow: 'demain matin',
        dndAtTimes: { '09:00': '9 h 00', '10:00': '10 h 00', '11:00': '11 h 00' },
        concierge: 'Conciergerie',
        conciergeTag: 'Serviettes, oreillers \u2014 tout ce qu\u2019il vous faut',
        conciergeTitle: 'De quoi avez-vous besoin ?',
        conMessage: 'Votre message',
        conMessagePlaceholder: 'p. ex. Deux serviettes suppl\u00e9mentaires svp',
        conMessageRequired: 'Veuillez nous dire ce dont vous avez besoin.',
        conSentTitle: 'Demande re\u00e7ue',
        conSentBody: "Notre \u00e9quipe a \u00e9t\u00e9 avis\u00e9e et s'en occupera.",
        conCat: {
            housekeeping: 'Entretien ménager',
            towels: 'Serviettes',
            soap: 'Savon / articles de toilette',
            pillows: 'Oreillers',
            iron: 'Fer \u00e0 repasser',
            luggage: 'Aide avec les bagages',
            missing_item: 'Objet manquant',
            other: 'Autre',
        },
    },
    es: {
        title: 'Plataforma de Asistencia al Hu\u00e9sped',
        submit: 'Enviar', requestSent: 'Solicitud enviada',
        detailsPlaceholder: 'Agregar detalles (opcional)',
        propertyPhotoHelper: 'Agregue una foto para ayudarnos a entender el problema (opcional).',
        room: 'Habitaci\u00f3n',
        roomTitle: '\u00bfEn qu\u00e9 habitaci\u00f3n se hospeda?',
        roomHint: 'Su n\u00famero de habitaci\u00f3n nos permite dirigir sus solicitudes al equipo correcto.',
        roomPlaceholder: 'N\u00famero de habitaci\u00f3n',
        continue: 'Continuar',
        roomNotFound: 'No encontramos esa habitaci\u00f3n. Verifique el n\u00famero.',
        roomInvalid: 'Ingrese un n\u00famero de habitaci\u00f3n v\u00e1lido.',
        demoRoomFormat: 'En esta demostraci\u00f3n, ingrese cualquier n\u00famero de habitaci\u00f3n o unidad de 3 d\u00edgitos (por ejemplo 214).',
        demoPinFormat: 'En esta demostraci\u00f3n, ingrese cualquier c\u00f3digo de 4 d\u00edgitos (por ejemplo 1234).',
        demoGuestCta: 'Continuar como hu\u00e9sped de demostraci\u00f3n (habitaci\u00f3n {room})',
        demoTenantCta: 'Continuar como inquilino de demostraci\u00f3n (unidad {unit})',
        demoTenantHint: 'O reg\u00edstrese arriba, como un residente real.',
        demoGuestHint: 'O reg\u00edstrese arriba, como un hu\u00e9sped real.',
        sessionExpired: 'Su sesi\u00f3n expir\u00f3. Confirme su habitaci\u00f3n nuevamente.',
        menuTitle: '\u00bfC\u00f3mo podemos ayudarle?',
        changeRoom: 'Cambiar de habitaci\u00f3n',
        residentAssistTitle: 'Portal de Comunicaci\u00f3n',
        roomTitleUnit: '\u00bfCu\u00e1l es su n\u00famero de unidad?',
        roomHintUnit: 'Su n\u00famero de unidad nos permite dirigir sus solicitudes al equipo correcto.',
        roomPlaceholderUnit: 'N\u00famero de unidad',
        changeUnit: 'Cambiar de unidad',
        sessionLength: 'Mantener la sesi\u00f3n durante',
        back: 'Volver',
        done: 'Listo',
        send: 'Enviar solicitud',
        sending: 'Enviando\u2026',
        requestProgress: 'Progreso de la solicitud',
        shieldSent: 'Enviada',
        shieldPending: 'Pendiente',
        shieldReceived: 'Recibida',
        shieldCompleted: 'Completada',
        shieldCancelled: 'Cancelada',
        shieldSentHint: 'Su solicitud fue enviada',
        shieldPendingHint: 'Esperando a que el equipo la vea',
        shieldReceivedHint: 'Un miembro del equipo vio su solicitud',
        receivedByAt: 'Recibida por {name} \u2014 {time}',
        shieldInProgress: 'En curso',
        shieldResolved: 'Resuelta',
        resolvedByAt: 'Resuelta por {name} \u2014 {time}',
        cancel: 'Cancelar',
        errorTitle: 'Algo sali\u00f3 mal',
        tryAgain: 'Reintentar',
        notAvailable: 'La plataforma de asistencia al hu\u00e9sped no est\u00e1 disponible en este momento.',
        welcomeTitle: 'Complete su registro de bienvenida',
        welcomeTag: 'Obtenga Wi-Fi y cu\u00e9ntenos sobre su llegada',
        messages: 'Sus mensajes del hotel',
        messagesTag: 'Mensajes y regalos de su hotel',
        communityBoard: 'Tabl\u00f3n comunitario',
        communityBoardTag: 'Avisos de la administraci\u00f3n del edificio',
        acknowledge: 'Confirmar lectura',
        acknowledged: 'Le\u00eddo y confirmado',
        activity: 'Actividad',
        activityUnit: 'Mis solicitudes',
        activityTag: 'Sus solicitudes, pedidos y propinas de esta estancia',
        activityTagUnit: 'Sus solicitudes y actualizaciones',
        umTile: 'Mensaje de unidad', umTileUnit: 'Mensaje a un vecino', umTileHotel: 'Mensaje a un hu\u00e9sped',
        tapEntryTile: 'Entrada Tap', tapEntryTag: 'Acceso seguro a la puerta',
        vstTile: 'Visitantes', vstTag: 'Conversaciones en su puerta', vstNew: 'nuevo(s)',
        vstTitle: 'Visitantes', vstUnit: 'Unidad', vstEmpty: 'Ningún visitante ha usado su código de entrada todavía.',
        vstActive: 'Activa', vstEnded: 'Finalizada', vstBack: 'Volver a visitantes',
        vstVisitorAt: 'Visitante en', vstStarted: 'Llegó', vstNoMessages: 'Sin mensajes',
        vstThreadEmpty: 'Nada por ahora. Escriba primero si lo desea.',
        vstPlaceholder: 'Escribir al visitante…', vstNotify: 'Avisar al visitante',
        vstNotified: 'Visitante avisado', vstClosed: 'Esta sesión de visitante ha finalizado.',
        vstPrivacy: 'El visitante nunca ve su número ni su correo.',
        vstYou: 'Usted', vstVisitor: 'Visitante', vstAutoReply: 'Respuesta automática', vstChose: 'Eligió:',
        vstAtDoorNow: 'En su puerta ahora', vstNotAtDoor: 'No está en la puerta',
        vstErr: 'No se pudo enviar. Inténtelo de nuevo.',
        ppTile: 'Personas y acceso', ppTag: 'Qui\u00e9n puede contactarte en la puerta', ppTitle: 'Personas y acceso', ppUnit: 'Unidad',
        ppRoleMaster: 'Residente principal', ppRoleAdditional: 'Residente adicional', ppYou: 'T\u00fa',
        ppPeopleHdr: 'Personas en tu unidad', ppEmptyPeople: 'A\u00fan no se ha agregado a nadie.',
        ppAdd: 'Agregar una persona', ppName: 'Nombre completo', ppEmail: 'Correo (opcional)', ppPhone: 'Tel\u00e9fono (opcional)',
        ppSave: 'Guardar', ppCancel: 'Cancelar', ppSaving: 'Guardando\u2026',
        ppCap: 'Esta unidad ya tiene el m\u00e1ximo de 3 personas.', ppNotMaster: 'Solo el residente principal puede agregar personas.',
        ppNameReq: 'Ingresa un nombre.', ppErr: 'Algo sali\u00f3 mal. Int\u00e9ntalo de nuevo.',
        smsTitle: 'Av\u00edsame por mensaje cuando alguien est\u00e9 en mi puerta', smsSendTo: 'Los mensajes van al', smsNoPhone: 'No hay tel\u00e9fono registrado \u2014 agrega uno para recibir mensajes.',
        ahTitle: 'Acciones recientes', ahEmpty: 'Nada todavía — tus acciones recientes aparecerán aquí.',
        ahClearAll: 'Borrar todo', ahRemove: 'Quitar de mi lista',
        ahFootnote: 'Esta es tu propia lista. Quitar un elemento nunca cambia el registro.',
        ahAcknowledge: 'Atendida', ahResolve: 'Resuelta', ahCancel: 'Cancelada',
        smsOn: 'Activado', smsOff: 'Desactivado', smsPauseTitle: 'Pausar por', smsPause2h: '2 horas',
        smsPauseTomorrow: 'Hasta ma\u00f1ana 9:00', smsPause2d: '2 d\u00edas',
        smsPausedUntil: 'En pausa hasta {{when}}', smsResumeNow: 'Volver a activar',
        ppActionsHdr: 'Tus acciones para visitantes', ppActionsSub: 'Lo que un visitante puede hacer en tu puerta',
        ppEmptyActions: 'A\u00fan no hay acciones.', ppAddAction: 'Agregar una acci\u00f3n', ppActionType: 'Acci\u00f3n',
        ppActionCap: 'Puedes tener hasta 10 acciones.', ppComingSoon: 'Pr\u00f3ximamente', ppOn: 'Activado', ppOff: 'Desactivado',
        ppActionAdded: 'Acci\u00f3n agregada.', ppPersonAdded: 'Persona agregada.',
        ppNoteLabel: 'Nota para visitantes', ppNotePlaceholder: 'ej. Deja los paquetes en la conserjer\u00eda', ppAddNote: 'Agregar una nota', ppEditNote: 'Editar',
        atCall: 'Llamada', atMessage: 'Mensaje', atDeliveries: 'Entregas', atMaintenance: 'Mantenimiento',
        atParking: 'Estacionamiento', atPickup: 'Recogida', atConcierge: 'Conserjer\u00eda', atImAway: 'Estoy ausente', atCustom: 'Instrucci\u00f3n personalizada',

        annTile: 'Anuncios', annTag: 'Avisos de la administraci\u00f3n', annTitle: 'Anuncios', annEmpty: 'A\u00fan no hay anuncios.', annFrom: 'De la administraci\u00f3n', annAll: 'Todos los residentes', annFloor: 'Piso {n}', umSeen: 'Visto', annPinned: 'Fijado', annAck: 'Confirmar',
        homeReqTitle: 'Sus solicitudes', groupCommTile: 'Comunicación', groupCommTag: 'Avisos y anuncios', groupBuildingTile: 'Edificio y acceso', groupBuildingTag: 'Entrada, personas y edificio', groupServicesTile: 'Servicios', groupServicesTag: 'Residuos, estacionamiento y comodidades', groupOptions: 'opciones', commUnitTag: 'Enviado a su unidad', commAllTag: 'Enviado a todos los residentes',
        umTag: 'Contacte otra unidad en privado', umTagUnit: 'Contacte a un vecino en privado',
        umTitle: 'Mensajes de unidad', umStart: 'Iniciar un mensaje', umChooseUnit: 'Elegir una unidad',
        umNoUnits: 'No hay otras unidades disponibles por ahora.',
        umRequests: 'Solicitudes', umSent: 'Enviadas', umActive: 'Conversaciones', umClosed: 'Cerradas',
        umNone: 'A\u00fan no hay conversaciones. Toque \u00abIniciar un mensaje\u00bb para contactar otra unidad.',
        umWaiting: 'Esperando que acepten', umWantsToMessage: 'quiere enviarle un mensaje',
        umAccept: 'Aceptar', umIgnore: 'Ignorar', umClose: 'Finalizar conversaci\u00f3n', umReopen: 'Reabrir',
        umReopenHint: 'Deber\u00e1n aceptar de nuevo.', umCooldown: 'Esta unidad rechaz\u00f3 recientemente. Int\u00e9ntelo m\u00e1s tarde.',
        umClosedNote: 'Esta conversaci\u00f3n ha finalizado.', umNotActive: 'Acepte la solicitud para comenzar a chatear.',
        umMessagePlaceholder: 'Escriba un mensaje', umFirstMessagePlaceholder: 'A\u00f1ada un mensaje breve (opcional)', umPhotoHelper: 'Agrega una foto a tu mensaje (opcional).',
        umSendRequest: 'Enviar solicitud', umRequestSent: 'Solicitud enviada', umYou: 'Usted',
        umUnit: 'Unidad', umRoom: 'Habitaci\u00f3n', umError: 'Algo sali\u00f3 mal. Int\u00e9ntelo de nuevo.',
        timeJustNow: 'Ahora mismo', timeMinAgo: 'hace {n} min', timeHourAgo: 'hace {n} h', timeHoursAgo: 'hace {n} h', timeToday: 'Hoy', timeYesterday: 'Ayer',
        statusOpen: 'Enviada', statusHandling: 'Vista', statusResolved: 'Resuelta', statusCancelled: 'Cancelada',
        reqStepSent: 'Enviada', reqStepSeen: 'Vista', reqStepFixed: 'Resuelta',
        reqProgressLegend: 'Estado de una solicitud: enviada, luego vista por el personal y luego resuelta.',
        homeMore: 'Más opciones',
        fullMenu: 'Menú completo',
        groupedMenu: 'Agrupado',
        activityClear: 'Quitar de mi historial',
        activityTitle: 'Su actividad',
        activityEmpty: 'Sin actividad todav\u00eda durante esta estancia.',
        activityNoCharge: 'Sin cargo',
        activityTipWord: 'propina',
        activityDetailTitle: 'Detalle de la actividad',
        activityWhen: 'Cu\u00e1ndo',
        activityWho: 'Atendida por',
        activityStatus: 'Estado',
        activityAmount: 'Importe',
        activityNotYet: 'A\u00fan no',
        offers: 'Ofertas y tarjetas de regalo',
        offersTag: 'Ofertas especiales y tarjetas de regalo para su estancia',
        offersTitle: 'Ofertas y tarjetas de regalo',
        offersEmpty: 'No hay ofertas disponibles en este momento.',
        offerCode: 'C\u00f3digo',
        offerExpires: 'Vence',
        offerRedeemHint: 'Muestre este c\u00f3digo al personal del hotel para canjearlo.',
        poolTitle: 'Piscina y Terraza',
        poolTag: 'Pida sin salir de su tumbona',
        poolEmpty: 'No hay servicios de piscina disponibles ahora.',
        poolDrinks: 'Bebidas',
        poolDrinksTag: 'Pida bebidas a su lugar',
        poolFood: 'Comida',
        poolFoodTag: 'Pida comida a su lugar',
        poolTowels: 'Toallas',
        poolTowelsTag: 'Solicite toallas de piscina',
        poolTowelsBody: 'Le llevaremos toallas de piscina limpias.',
        poolOther: 'Otro servicio de piscina',
        poolOtherTag: 'Pida cualquier otra cosa',
        poolOtherLabel: '\u00bfC\u00f3mo podemos ayudar?',
        poolOtherPlaceholder: 'D\u00edganos qu\u00e9 necesita\u2026',
        poolMenuLabel: 'Men\u00fa',
        poolOrderLabel: '\u00bfQu\u00e9 desea?',
        poolOrderPlaceholder: 'ej. 2 mojitos, 1 s\u00e1ndwich club',
        poolLocationLabel: 'Tumbona / mesa (opcional)',
        poolLocationPlaceholder: 'ej. tumbona 12, cabana 3',
        poolSentTitle: 'Pedido recibido',
        poolSentBody: 'Nuestro equipo se encarga. Siga el progreso abajo.',
        poolCat: { drinks: 'Bebidas', food: 'Comida', towels: 'Toallas', other: 'Otro servicio de piscina' },
        poolTowelsOther: 'Toallas / Otro servicio', poolTowelsOtherTag: 'Toallas, revistas y más',
        poolSecurityMedical: 'Seguridad / Médico', poolSecurityMedicalTag: 'Asistencia urgente',
        poolFullMenu: 'Menú completo del hotel',
        poolMagazine: 'Revista / Lectura', poolOtherSvc: 'Otro servicio',
        poolTowelsQty: '¿Cuántas toallas?', poolNotes: 'Notas adicionales',
        poolContinueFood: 'Continuar al menú de comida', poolContinueDrink: 'Continuar al menú de bebidas',
        poolReview: 'Revisar pedido', poolConfirmPlace: 'Confirmar y enviar pedido', poolYourOrder: 'Su pedido',
        poolPinPrompt: 'Introduzca su código de 4 dígitos', poolPinError: 'Código no válido',
        poolSecurity: 'Seguridad', poolMedical: 'Médico',
        poolSecurityDesc: 'Asistencia de seguridad urgente', poolMedicalDesc: 'Asistencia médica',
        poolChoose: 'Elija el tipo de asistencia',
        noMessages: 'No hay mensajes por ahora.',
        hotelMessage: 'Mensaje de su hotel',
        voucherGift: 'Un regalo para usted',
        viewVoucher: 'Ver su vale de regalo',
        voucherRedeemed: 'Este regalo ya fue canjeado. \u00a1Disfr\u00fatelo!',
        voucherExpires: 'V\u00e1lido hasta el',
        opensNewTab: 'Se abre en una pesta\u00f1a nueva \u2014 su sesi\u00f3n aqu\u00ed sigue activa.',
        security: 'Seguridad',
        securityTag: 'Asistencia inmediata, a cualquier hora',
        urgentButton: 'URGENTE \u2014 Llamar a seguridad',
        urgentConfirmTitle: '\u00bfEnviar alerta de seguridad urgente?',
        urgentConfirmBody: 'El equipo de seguridad ser\u00e1 notificado de inmediato con su n\u00famero de habitaci\u00f3n.',
        confirmSend: 'S\u00ed, enviar ahora',
        urgentSentTitle: 'Seguridad ha sido alertada',
        urgentSentBody: 'Su n\u00famero de habitaci\u00f3n y la hora fueron enviados al equipo de seguridad.',
        standardTitle: 'Reportar un problema',
        selectCategory: '\u00bfDe qu\u00e9 se trata?',
        detailsOptional: 'Detalles (opcional)',
        detailsPlaceholder: 'Cu\u00e9ntenos qu\u00e9 est\u00e1 pasando\u2026',
        securitySentTitle: 'Solicitud enviada',
        securitySentBody: 'El equipo de seguridad ha sido notificado.',
        secCat: {
            noisy_neighbour: 'Vecino ruidoso',
            hallway_disturbance: 'Disturbio en el pasillo',
            suspicious_activity: 'Actividad sospechosa',
            guest_visitor_issue: 'Problema con hu\u00e9sped / visitante',
            room_security_concern: 'Seguridad de la habitaci\u00f3n',
            other: 'Otro',
        },
        hotelInfo: 'Informaci\u00f3n del hotel',
        hotelInfoTag: 'Horarios, comodidades y servicios',
        hours: 'Horario',
        moreInfo: 'M\u00e1s informaci\u00f3n',
        food: 'Comida y restaurantes',
        foodTag: 'Restaurante, servicio a la habitaci\u00f3n y opciones cercanas',
        hotelRestaurant: 'Restaurante del hotel',
        roomService: 'Servicio a la habitaci\u00f3n',
        viewMenu: 'Ver men\u00fa',
        partners: 'Restaurantes asociados cercanos',
        visitSite: 'Visitar sitio web',
        restaurants: 'Restaurantes',
        reserve: 'Reservar una mesa',
        giftCards: 'Tarjetas de regalo disponibles',
        backToApp: 'Volver a YULONTAP',
        welcomeBack: 'Bienvenido de nuevo',
        notYou: '\u00bfNo es {name}?',
        firstName: 'Nombre',
        stayHowLong: '\u00bfCu\u00e1nto tiempo se queda?',
        day: 'd\u00eda',
        days: 'd\u00edas',
        otherStay: 'Otro / estancia m\u00e1s larga',
        daysPlaceholder: 'N\u00famero de d\u00edas',
        pinCreateTitle: 'CREE SU PIN DE 4 D\u00cdGITOS',
        pinLabel: 'Elija 4 d\u00edgitos',
        pinHint: 'Usted crea este PIN \u2014 el hotel no lo proporciona. Confirma sus compras y propinas a trav\u00e9s del hotel.',
        nameRequired: 'Ingrese su nombre.',
        daysRequired: 'Elija la duraci\u00f3n de su estancia.',
        pinRequired: 'Elija un PIN de 4 d\u00edgitos.',
        residentIdentifyHint: 'Ingrese su unidad y su nombre.',
        pinEnterTitle: 'INGRESE SU PIN DE 4 D\u00cdGITOS',
        residentPinCreateHint: 'Cree un PIN permanente de 4 d\u00edgitos. Lo usar\u00e1 cada vez que acceda a su edificio.',
        residentPinEnterHint: 'Ingrese el PIN que cre\u00f3.',
        residentNotVerified: 'No pudimos verificar su unidad y su nombre. Comun\u00edquese con la administraci\u00f3n del edificio.',
        tipRoomService: 'Propina \u2014 servicio a la habitaci\u00f3n',
        priorityBadge: 'Prioritario',
        priorityHeading: 'Mensaje importante de su hotel',
        priorityAck: 'Lo he le\u00eddo \u2014 Continuar',
        priorityMore: 'Sigue otro mensaje importante',
        valet: 'Valet Parking',
        valetTag: 'Solicite su veh\u00edculo',
        bringMyCar: 'Traigan mi coche',
        valetWhen: '\u00bfCu\u00e1ndo desea su veh\u00edculo?',
        now: 'Ahora',
        in15: 'En 15 minutos',
        in30: 'En 30 minutos',
        in1h: 'En 1 hora',
        in2h: 'En 2 horas',
        untilTime: 'A una hora espec\u00edfica',
        guestName: 'Nombre del hu\u00e9sped',
        vehicleMake: 'Marca',
        vehicleModel: 'Modelo',
        vehicleColor: 'Color',
        vehiclePlate: 'Matr\u00edcula',
        valetOptionalHint: 'El color y la matr\u00edcula son opcionales \u2014 nos ayudan a identificar su veh\u00edculo m\u00e1s r\u00e1pido.',
        valetSubmit: 'Solicitar mi veh\u00edculo',
        valetSentTitle: 'Su veh\u00edculo ha sido solicitado',
        valetSentBody: 'Solicitado para las',
        valetTicket: 'Su boleto de valet',
        valetRequestedFor: 'Solicitado para',
        valetAnother: 'Solicitar otro veh\u00edculo',
        valetError: 'Algo sali\u00f3 mal \u2014 int\u00e9ntelo de nuevo.',
        valet_retrieval_requested: 'Solicitado',
        valet_retrieving: 'En camino',
        valet_ready: 'Listo en la entrada',
        valet_delivered: 'Entregado',
        valet_cancelled: 'Cancelado',
        tipHousekeeping: 'Propina \u2014 limpieza',
        tipConcierge: 'Propina \u2014 conserjer\u00eda',
        tipValet: 'Propina \u2014 valet',
        tipSoon: 'El hotel est\u00e1 activando las propinas seguras \u2014 disponible muy pronto.',
        tipHowMuch: '\u00bfCu\u00e1nto desea dar de propina?',
        tipOtherAmount: 'Otro monto',
        tipAmountPlaceholder: 'Monto ($)',
        tipSend: 'Enviar propina',
        tipThanksTitle: '\u00a1Gracias!',
        tipThanksBody: 'Su propina de {amount} para {recipient} qued\u00f3 registrada en el hotel.',
        tipError: 'No pudimos registrar su propina \u2014 int\u00e9ntelo de nuevo.',
        tipRecipient: {
            concierge: 'el equipo de conserjer\u00eda',
            housekeeping: 'el equipo de limpieza',
            valet: 'el equipo de valet',
            room_service: 'el servicio a la habitaci\u00f3n',
        },
        destChecking: 'Abriendo\u2026',
        destExternalNote: 'Este sitio oficial se abre en su navegador. Su sesi\u00f3n aqu\u00ed sigue activa \u2014 simplemente vuelva a esta pesta\u00f1a.',
        destOpenSite: 'Abrir el sitio oficial',
        destOpened: 'El sitio se abri\u00f3 en una pesta\u00f1a nueva. Vuelva aqu\u00ed cuando quiera \u2014 no necesita escanear de nuevo.',
        entertainment: 'Entretenimiento',
        entertainmentTag: 'Entretenimiento en la habitaci\u00f3n',
        entEvents: 'Eventos',
        entMovies: 'Cine',
        entPlaces: 'Lugares locales',
        entPartners: 'Restaurantes',
        entPartnerVisit: 'Visitar',
        entPartnersNote: 'Restaurantes asociados \u2014 cada enlace abre el sitio web del restaurante.',
        entMoviesSub: 'Pel\u00edculas y horarios cercanos',
        entShowtimes: 'Cartelera y horarios',
        entTickets: 'Detalles y entradas',
        entLoading: 'Buscando actividades cercanas\u2026',
        entNoEvents: 'No se encontraron eventos cercanos para este filtro. Pruebe otro.',
        entUnavailable: 'Los eventos en vivo no est\u00e1n disponibles temporalmente. Vuelva pronto.',
        fToday: 'Hoy',
        fTonight: 'Esta noche',
        fWeekend: 'Este fin de semana',
        fWeek: 'Pr\u00f3ximos 7 d\u00edas',
        fComingUp: 'Pr\u00f3ximamente',
        cAll: 'Todos',
        cMusic: 'M\u00fasica',
        cSports: 'Deportes',
        cTheatre: 'Teatro',
        cFamily: 'Familia',
        cat_cinema: 'Cine',
        cat_theatre: 'Teatro',
        cat_museum: 'Museo',
        cat_attraction: 'Atracci\u00f3n',
        cat_venue: 'Sala de espect\u00e1culos',
        cat_festival: 'Festival',
        cat_tourism: 'Turismo',
        cat_convention: 'Centro de convenciones',
        cat_sports: 'Recinto deportivo',
        cat_nightlife: 'Vida nocturna',
        cat_family: 'Familia',
        cat_other: 'Lugar local',
        housekeeping: 'Limpieza',
        housekeepingTag: 'Limpieza, suministros y m\u00e1s',
        dndTitle: 'No molestar',
        dndBody: 'Indique a limpieza que no pase antes de:',
        dndConfirm: 'Activar No molestar',
        dndSetTitle: 'No molestar activado',
        dndSetBody: 'Limpieza no le molestar\u00e1 antes de las',
        dndTomorrow: 'ma\u00f1ana por la ma\u00f1ana',
        dndAtTimes: { '09:00': '9:00 AM', '10:00': '10:00 AM', '11:00': '11:00 AM' },
        concierge: 'Conserjer\u00eda',
        conciergeTag: 'Toallas, almohadas \u2014 lo que necesite',
        conciergeTitle: '\u00bfQu\u00e9 necesita?',
        conMessage: 'Su mensaje',
        conMessagePlaceholder: 'p. ej. Dos toallas adicionales por favor',
        conMessageRequired: 'D\u00edganos qu\u00e9 necesita.',
        conSentTitle: 'Solicitud recibida',
        conSentBody: 'Nuestro equipo ha sido notificado y se encargar\u00e1.',
        conCat: {
            housekeeping: 'Limpieza',
            towels: 'Toallas',
            soap: 'Jab\u00f3n / art\u00edculos de aseo',
            pillows: 'Almohadas',
            iron: 'Plancha',
            luggage: 'Ayuda con el equipaje',
            missing_item: 'Objeto perdido',
            other: 'Otro',
        },
    },
};
